import { render, staticRenderFns } from "./Mandates.vue?vue&type=template&id=25c678ae&scoped=true&"
import script from "./Mandates.vue?vue&type=script&lang=js&"
export * from "./Mandates.vue?vue&type=script&lang=js&"
import style0 from "./Mandates.vue?vue&type=style&index=0&id=25c678ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c678ae",
  null
  
)

export default component.exports